import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ContextualHelpModel } from 'src/app/models/contextualHelp';
import { ContextualHelpService } from 'src/app/services/contextualHelpService';
import { CreateOrEditContextualHelpComponent } from '../create-or-edit-contextual-help/create-or-edit-contextual-help.component';
import {  clone, cloneDeep } from 'lodash';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from 'src/app/services/endpoints.service';

@Component({
  selector: 'app-contextual-help',
  templateUrl: './contextual-help.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class ContextualHelpComponent implements OnInit{
  constructor(public bsModalRef : BsModalRef,
    public contextualHelpService: ContextualHelpService,
    public bsModalService: BsModalService,
    public http : HttpClient,
    public endpointService:EndpointsService

    ){

  }
  ngOnInit(): void {
    this.contextualHelpService.contextualHelpToolTips =
    cloneDeep(this.contextualHelpService.contextualHelpToolTips.sort((a,b)=> {
      if(a.functionality < b.functionality){
        return -1;
      }
      if(a.functionality > b.functionality){
        return 1;
      }
      return 0;
    }));
  }
  selectEnabled(contextualHelp:ContextualHelpModel){
    contextualHelp.isEnabled = !contextualHelp.isEnabled;
  }
  edit(index: number){
    const bsModalRef = this.bsModalService.show(CreateOrEditContextualHelpComponent);

    bsModalRef.content.contextualHelp = cloneDeep(this.contextualHelpService.contextualHelpToolTips[index]);
    bsModalRef.content.edit = true;
    bsModalRef.content.onClose.subscribe((newContextualHelp:ContextualHelpModel)=>{
        this.contextualHelpService.contextualHelpToolTips[index] = cloneDeep(newContextualHelp);
      }
    )

  }


}
